<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="loading"
         class="loading-container">
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentManagerDetailRedirect',
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.login.user
    })
  },
  watch: {
    '$route': {
      handler () {
        this.checkUserTypeAndRedirect()
      },
      immediate: true
    }
  },
  methods: {
    checkUserTypeAndRedirect () {
      const id = parseInt(this.$route.params.id) || 0

      if (!id) {
        this.loading = false
        return
      }
      try {
        // 根据用户类型判断跳转路径
        if (this.user && this.user.usertype * 1 === 5) {
          // usertype=5 跳转到财务详情页面
          const targetPath = `/payment-approval-new/detail/${id}`
          this.$router.replace(targetPath)
        } else {
          // 其他用户类型跳转到普通详情页面
          const targetPath = `/payment-manager-new/detail/${id}`
          this.$router.replace(targetPath)
        }
      } catch (error) {
        console.error('页面跳转失败：', error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    // 延迟设置加载状态，确保用户信息已加载
    setTimeout(() => {
      this.loading = false
    }, 100)
  }
}
</script>

<style lang="scss"
       scoped>
.loading-container {
  padding: 20px;
  text-align: center;
}

.loading-text {
  color: #666;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/payment-manager-new/pages/PaymentManagerDetailRedirect.vue